import { IWsMatchStats } from '@/app/core/websocket/models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, of } from 'rxjs';
import { GoogleTagAnalyticsService } from '../../../../../services/google-tag/google-tag-analytics.service';
import { EGoogleTagAnalyticsKeys } from '../../enums';
import { emptyMatchStats, MatchStats } from '../models';

@Injectable({
  providedIn: 'root',
})
export class MatchStatsService {
  private http = inject(HttpClient);
  private env = environment;
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });
  private googleTagAnalyticsService = inject(GoogleTagAnalyticsService);

  isLoadingMatchStats = signal<boolean>(false);
  isErrorMatchStats = signal<boolean>(false);
  matchStats = signal<MatchStats>(emptyMatchStats);
  wsMatchStats = signal<IWsMatchStats | null>(null);

  getMatchStats(matchId: String, isRefreshing: boolean = false) {
    if (!isRefreshing) this.isLoadingMatchStats.set(true);
    this.isErrorMatchStats.set(false);

    this.http
      .get<MatchStats>(`${this.env.baseUrlWeb}/matches/${matchId}/stats`, {
        headers: this.headers,
      })
      .pipe(
        catchError((_) => {
          this.isLoadingMatchStats.set(false);
          this.isErrorMatchStats.set(true);

          return of(null);
        })
      )
      .subscribe((data) => {
        if (!data) return;

        this.matchStats.set(data);
        this.isLoadingMatchStats.set(false);

        // google analytics
        this.googleTagAnalyticsService.event(
          EGoogleTagAnalyticsKeys.VIEW_STATS,
          {
            match_id: matchId,
            stats: data,
          }
        );
      });
  }

  setWsMatchStats(data: IWsMatchStats) {
    this.wsMatchStats.set(data);
  }
}
